import { Middleware } from "redux";
import { IStore } from "redux/store";
import vdmDashboardActions, {
	EVDMDashboardActions,
	TVDMDashbaordActions,
	vdmDashboardJobActions,
} from "./actions";
import { apiActions } from "redux/_core/api";
import vdmDashboardAPIS from "./api";
import {
	IVDMBunkerData,
	IVDMConsumption,
	IVDMDashboardContent,
	IVDMPICContent,
	IVDMPICDepartment,
	IVDMPICPerson,
	IVDMVesselStatus,
} from "./@types";
import {
	draftSpeedImpactOnFuelConsumptionData,
	loadVDMBunkerTabData,
	vdmConsumptionTabData,
	vdmFuelConsumptionDistanceCovered,
	vdmSmartAlertsData,
	vdmVesselStatusData,
} from "./data";
import vdmDashboardSelectors from "./selectors";
import { format } from "date-fns";
import userActions from "../user/actions";
import { vdmDashboardUtils } from "./utils";
import { cloneDeep } from "lodash";

const { removeProfilePictures, getMonthlyRange } = vdmDashboardUtils;
const { apiRequest } = apiActions;

const vdmDashboardMiddleware: Middleware<any, IStore, any> =
	({ dispatch, getState }) =>
	(next) =>
	(action: TVDMDashbaordActions) => {
		switch (action.type) {
			case EVDMDashboardActions.VDM_VESSEL_STATUS_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vesselVDMStatusLoad;
				const { vesselId } = action.payload;

				dispatch(
					apiRequest<IVDMVesselStatus[]>({
						...vdmDashboardAPIS.loadVDMVesselStatus(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									vdmDashboardActions.document.vdmVesselStatusSet(
										data?.length ? data : [],
									),
								);
							},
							onError() {
								dispatch(
									job.error({
										message:
											"Failed to load garbage discharge report for all vessels",
									}),
								);

								dispatch(
									vdmDashboardActions.document.vdmVesselStatusSet(
										vdmVesselStatusData,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);
				break;
			}
			// 	case EVDMDashboardActions.VDM_VESSEL_TAB_LOAD: {
			// 	next(action);

			// 	const job = vdmDashboardJobActions.vesselVDMTabLoad;
			// 	const { vesselId, tabType } = action.payload;

			// 	dispatch(
			// 		apiRequest<IVDMBunkerData>({
			// 			...vdmDashboardAPIS.loadVDMVesselTab(vesselId, tabType),
			// 			preExecute() {
			// 				dispatch(job.active({}));
			// 			},
			// 			postExecute: {
			// 				onSuccess({ data }) {
			// 					switch (tabType) {
			// 						case VDM_DASHBOARD_TABS.BUNKER:
			// 							dispatch(
			// 								vdmDashboardActions.document.vdmTabDataSet(
			// 									tabType,
			// 									data ?? undefined
			// 								)
			// 							);
			// 							break;

			// 						case VDM_DASHBOARD_TABS.CONSUMPTION: {
			// 							const modifiedData = data;
			// 							if (tabType in modifiedData) delete modifiedData[tabType];

			// 							dispatch(
			// 								vdmDashboardActions.document.vdmTabDataSet(
			// 									tabType,
			// 									data ?? undefined
			// 								)
			// 							);

			// 							break;
			// 						}
			// 					}
			// 				},
			// 				onError() {
			// 					dispatch(
			// 						job.error({
			// 							message:
			// 								"Failed to load garbage discharge report for all vessels",
			// 						})
			// 					);
			// 				},
			// 				finally() {
			// 					dispatch(job.idle({}));
			// 				},
			// 			},
			// 		})
			// 	);

			// 	break;
			// }

			case EVDMDashboardActions.VDM_BUNKER_TAB_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmBunkerTabLoad;
				const { vesselId } = action.payload;

				dispatch(
					apiRequest<IVDMBunkerData>({
						...vdmDashboardAPIS.loadVDMBunkerTab(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									vdmDashboardActions.document.vdmBunkerTabDataSet(
										data ?? undefined,
									),
								);
							},
							onError(err) {
								console.error(err);
								dispatch(
									job.error({
										message: "Failed to load bunker stats",
									}),
								);
								// TODO: needs to be removed
								dispatch(
									vdmDashboardActions.document.vdmBunkerTabDataSet(
										loadVDMBunkerTabData,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);

				break;
			}

			case EVDMDashboardActions.VDM_CONSUMPTION_TAB_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmConsumptionTabLoad;
				const { vesselId } = action.payload;

				dispatch(
					apiRequest<IVDMConsumption>({
						...vdmDashboardAPIS.loadVDMConsumptionTab(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								// @ts-ignore
								if (data?.tabType) delete data.tabType;
								dispatch(
									vdmDashboardActions.document.vdmConsumptionTabDataSet(
										data ?? undefined,
									),
								);
							},
							onError(err) {
								console.error(err);
								dispatch(
									job.error({
										message: "Failed to load consumption stats",
									}),
								);
								// TODO: Needs to be removed.
								dispatch(
									vdmDashboardActions.document.vdmConsumptionTabDataSet(
										vdmConsumptionTabData as any,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);

				break;
			}

			case EVDMDashboardActions.VDM_SMART_ALERTS_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmSmartAlertsLoad;
				const { vesselId } = action.payload;
				dispatch(
					apiRequest({
						...vdmDashboardAPIS.loadVDMSmartAlerts(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									vdmDashboardActions.document.vdmSmartAlertsSet(
										!data?.smartAlerts?.length ? [] : data?.smartAlerts,
									),
								);
							},
							onError(err) {
								dispatch(
									job.error({
										message: "Failed to load alerts for the vessel.",
									}),
								);
								console.error("Error loading smart alerts", err);
								// TODO: needs to be removed
								dispatch(
									vdmDashboardActions.document.vdmSmartAlertsSet(
										vdmSmartAlertsData?.smartAlerts as any,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);
				break;
			}
			case EVDMDashboardActions.VDM_FUEL_CONSUMPTION_DISTANCE_COVERED_LOAD: {
				next(action);
				const job =
					vdmDashboardJobActions.vdmFuelConsumptionDistanceCoveredLoad;
				const { vesselId, duration } = action.payload;

				dispatch(
					apiRequest({
						...vdmDashboardAPIS.loadFuelConsumptionDistanceCovered(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								if (data?.data) {
									dispatch(
										vdmDashboardActions.document.vdmFuelConsumptionDistanceCoveredSet(
											data?.data,
										),
									);
								}
							},
							onError(err) {
								console.error(err);
								dispatch(
									job.error({
										message: "Failed to load fuel consumption distance covered",
									}),
								);
								// TODO: Needs to be removed
								dispatch(
									vdmDashboardActions.document.vdmFuelConsumptionDistanceCoveredSet(
										vdmFuelConsumptionDistanceCovered,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);
				break;
			}

			case EVDMDashboardActions.VDM_DRAFT_SPEED_IMPACT_ON_FUEL_CONSUMPTION_LOAD: {
				next(action);
				const job =
					vdmDashboardJobActions.vdmDraftSpeedImpactOnFuelConsumptionLoad;
				const { vesselId } = action.payload;

				dispatch(
					apiRequest({
						...vdmDashboardAPIS.loadDraftSpeedImpactOnFuelConsumption(vesselId),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								if (data?.data) {
									dispatch(
										vdmDashboardActions.document.vdmDraftSpeedImpactOnFuelConsumptionSet(
											data?.data,
										),
									);
								}
							},
							onError(err) {
								console.error(err);
								dispatch(
									job.error({
										message:
											"Failed to load draft speed impact on fuel consumption",
									}),
								);
								dispatch(
									vdmDashboardActions.document.vdmDraftSpeedImpactOnFuelConsumptionSet(
										draftSpeedImpactOnFuelConsumptionData,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);
				break;
			}

			case EVDMDashboardActions.VDM_CNR_DATE_RANGE_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmCNRDateRangeLoad;
				const { params } = action.payload;
				const authStore = getState().app.auth;
				// @ts-ignore
				const userId = authStore.user?.userId ?? "";
				const token = authStore?.authToken ?? "";

				dispatch(
					apiRequest({
						...vdmDashboardAPIS.loadCNRForGivenDateRange({
							...params,
							userId,
							token,
						}),
						preExecute() {
							dispatch(job.active({}));
						},
						postExecute: {
							onSuccess({ data }) {
								dispatch(
									vdmDashboardActions.document.vdmCNRForDateRangeSet(
										data?.length ? data : [],
									),
								);
								if (!data?.length) {
									// also reset the selected date.
									dispatch(
										vdmDashboardActions.document.vdmDashboardSelectedDateSet(
											"",
										),
									);
								}
							},
							onError(err) {
								console.error(err);
								dispatch(
									job.error({
										message:
											"Failed to load CNR reports for the given date range.",
									}),
								);
								dispatch(
									vdmDashboardActions.document.vdmDraftSpeedImpactOnFuelConsumptionSet(
										draftSpeedImpactOnFuelConsumptionData,
									),
								);
							},
							finally() {
								dispatch(job.idle({}));
							},
						},
					}),
				);

				break;
			}

			case EVDMDashboardActions.VDM_DASHBOARD_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmDashboardLoad;
				const { params } = action.payload;
				const { cnrId, vesselId } = params;
				const authStore = getState().app.auth;
				// @ts-ignore
				// const userId = authStore.user?.userId ?? "";
				const token = authStore?.authToken ?? "";
				if (vesselId) {
					dispatch(
						apiRequest<IVDMDashboardContent>({
							...vdmDashboardAPIS.loadVDMDashboard({
								cnrId,
								vesselId,
								token,
							}),
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data }) {
									dispatch(
										vdmDashboardActions.document.vdmDashboardContentSet(
											data ? data : null,
										),
									);
									if (data) {
										const vdmStore =
											vdmDashboardSelectors._getStore(getState());
										const selectedDate =
											vdmDashboardSelectors.getVDMDashboardSelectedDate(
												vdmStore,
											);

										const selectedDateTrim = selectedDate?.split("T")[0];
										const selectedDateInContent =
											data?.selectedDate?.split("T")[0];

										if (selectedDateTrim !== selectedDateInContent) {
											dispatch(
												vdmDashboardActions.document.vdmDashboardSelectedDateSet(
													selectedDateInContent,
												),
											);

											// Check if the current selected date's month differs from selectedDateInContent's month
											const oldMonth = selectedDateTrim?.substring(0, 7);
											const newMonth = selectedDateInContent?.substring(0, 7);

											if (oldMonth !== newMonth) {
												const { start, end } = getMonthlyRange(
													selectedDateInContent
														? new Date(selectedDateInContent + "T00:00:00.000Z")
														: undefined,
												);
												dispatch(
													vdmDashboardActions.commands.vdmCNRDateRangeLoad({
														vesselId,
														start,
														end,
													}),
												);
											}
										}
									}
								},
								onError(err) {
									console.error(err);
									dispatch(
										job.error({
											message:
												"Failed to load VDM Dashboard for the selected day.",
										}),
									);
									dispatch(
										vdmDashboardActions.document.vdmDashboardContentSet(null),
									);

									// dispatch(
									// 	vdmDashboardActions.document.vdmDraftSpeedImpactOnFuelConsumptionSet(
									// 		draftSpeedImpactOnFuelConsumptionData,
									// 	),
									// );
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						}),
					);
				}
				break;
			}

			case EVDMDashboardActions.VDM_PIC_LOAD: {
				next(action);
				const job = vdmDashboardJobActions.vdmPICLoad;
				const { vesselId } = action.payload;

				const authStore = getState().app.auth;
				const token = authStore?.authToken ?? "";

				if (vesselId) {
					dispatch(
						apiRequest<IVDMPICContent>({
							...vdmDashboardAPIS.loadVDMPIC({
								vesselId,
								token,
							}),
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data }) {
									console.log({ data });
									dispatch(
										vdmDashboardActions.document.vdmPICContentSet(
											data ? data?.departments : null,
										),
									);
								},
								onError(err) {
									console.error(err);
									dispatch(
										job.error({
											message: "Failed to load VDM PIC for the selected day.",
										}),
									);
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						}),
					);
				}
				break;
			}

			case EVDMDashboardActions.VDM_PIC_SAVE_VESSEL_PIC: {
				next(action);
				const job = vdmDashboardJobActions.vdmPICSave;
				const { vesselId, departmentWiseAssignment } = action.payload;

				const authStore = getState().app.auth;
				const token = authStore?.authToken ?? "";

				const departments = removeProfilePictures(departmentWiseAssignment);

				if (vesselId && departments) {
					dispatch(
						apiRequest({
							...vdmDashboardAPIS.saveVDMPIC({
								vesselId,
								token,
								departments,
							}),
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data }) {
									console.log("Save", { data });
									dispatch(
										vdmDashboardActions.document.vdmPICContentSet(
											data ? data?.departments : null,
										),
									);
									dispatch(vdmDashboardActions.commands.vdmPICLoad(vesselId));
									dispatch(userActions.commands.userListLoad(1, false));

									dispatch(
										job.success({
											message: "VDM PIC saved successfully.",
										}),
									);
								},
								onError(err) {
									console.error(err);
									dispatch(
										job.error({
											message: "Failed to save VDM PIC for the vessel.",
										}),
									);
									dispatch(vdmDashboardActions.commands.vdmPICLoad(vesselId));
									dispatch(
										dispatch(userActions.commands.userListLoad(1, false)),
									);
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						}),
					);
				}
				break;
			}

			case EVDMDashboardActions.VDM_PIC_UPLOAD_PIC_PICTURE: {
				next(action);
				const job = vdmDashboardJobActions.uploadPICProfilePicture;
				const { userId, file, vesselId } = action.payload;

				const formData = new FormData();
				formData.append("vesselId", vesselId);
				formData.append("userId", userId);
				formData.append("attachment", file);

				const authStore = getState().app.auth;
				const token = authStore?.authToken ?? "";

				if (formData instanceof FormData) {
					dispatch(
						apiRequest({
							...vdmDashboardAPIS.uploadVDMPICProfilePicture({
								formData,
								token,
							}),
							preExecute() {
								dispatch(job.active({}));
							},
							postExecute: {
								onSuccess({ data }) {
									const { userId: uploadedUserId, profile_picture } = data;

									const vdmDashboardStore =
										vdmDashboardSelectors._getStore(getState());
									const departments =
										vdmDashboardSelectors.getVDMPICDepartmentWiseAssignment(
											vdmDashboardStore,
										);

									if (departments) {
										const roles: (keyof IVDMPICDepartment)[] = [
											"manager",
											"superintendent",
											"executive",
										];
										const updatedDepartments: IVDMPICContent["departments"] =
											cloneDeep(departments);

										for (const deptKey of Object.keys(
											updatedDepartments,
										) as (keyof typeof updatedDepartments)[]) {
											const department = updatedDepartments[deptKey];

											for (const role of roles) {
												const person = department[role];
												if (
													person &&
													typeof person === "object" &&
													"id" in person &&
													(person as IVDMPICPerson).id === uploadedUserId
												) {
													department[role] = {
														...(person as IVDMPICPerson),
														profile_picture,
													};
												}
											}
										}

										dispatch(
											vdmDashboardActions.document.vdmPICContentSet(
												updatedDepartments,
											),
										);
										setTimeout(() => {
											dispatch(
												vdmDashboardActions.commands.vdmPICLoad(vesselId),
											);
										}, 2500);
									}

									dispatch(
										job.success({
											message: "Profile picture uploaded successfully.",
										}),
									);
								},
								onError(err) {
									console.error(err);
									dispatch(
										job.error({
											message: "Failed to upload profile picture.",
										}),
									);
								},
								finally() {
									dispatch(job.idle({}));
								},
							},
						}),
					);
				}
				break;
			}

			default:
				next(action);
		}
	};

export default vdmDashboardMiddleware;
